export const module = {
  info: {
    name: 'voip-test-automation',
    caption: 'Automation Test',
    viewGroup: 'testing-tools'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Automated Tests',
    icon: 'el-icon-refresh',
    children: [
      {
        caption: 'Tests',
        icon: 'el-icon-refresh',
        routeName: 'module->voip-test-automation->automation',
        routeParams: { listPage: 1},
        // notAllowedProfiles: [4, 15],
        notAllowedProfiles: [],
      },
      {
        caption: 'History',
        icon: 'el-icon-s-grid',
        routeName: 'module->voip-test-automation->history',
        routeParams: { listPage: 1},
      },
    ]
  }
}

export default module
